import { Grid } from "@material-ui/core";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import banner from "../images/banner_4.jpg";
import * as data from '../Data'
import { Cookies, getCookie } from 'typescript-cookie'
import { Link } from "react-router-dom";
import { Member } from "../interfaces/Member";
import { useEffect, useState } from "react";
import image1 from '../images/image_1.jpg';
import image2 from '../images/image_5.jpg';
import image3 from '../images/image_3.jpg';
import logo from '../images/epic-logo.png';

const removeModal = () => {
    const partnerModal = document.getElementById('partner-modal') || undefined;

    if (partnerModal) {
        partnerModal.style.display = 'none';

    }
}

const visitPartner = (url: string) => {
    const partnerModal = document.getElementById('partner-modal') || undefined;

    if (partnerModal) {
        partnerModal.style.display = 'block';

    }

    const partnerLink = document.getElementById('partner-link') as HTMLAnchorElement || undefined;

    if (partnerLink) {
        partnerLink.href = url;        
    } else {
        console.log('no partnerLink');
    }

}

export function PlanVacation() {
    const [owner, setOwner] = useState<Member>();
    const [sorLink, setSorLink] = useState('');
    const [rciLink, setRciLink] = useState('');

    useEffect(() => {
        const ownerCookie = getCookie('owner') || undefined;

        if (ownerCookie) {
            setOwner(JSON.parse(ownerCookie) as Member);
            const member = JSON.parse(ownerCookie) as Member;
            setRciLink(member.rciLink);

            const getSorLink = async () => {
                const memberWithSorLink = await data.partnerLogin(
                    member,
                    (member) => {
                        setSorLink(member.sorLink);
                    },
                    (error) => {
                        console.log(error);
                    })
            }

            getSorLink();

        } else {
            window.location.href = "/login";
        }
    }, [])

    return (
        <div>

            {owner && <Header owner={owner} />}

            {owner &&
                <div>
                    <div id='partner-modal' style={{ display: 'none' }}>
                        <div style={{ position: 'fixed', top: '0', left: '0', backgroundColor: 'black', opacity: '.6', zIndex: '1', width: '100vw', height: '100vh' }}>
                        </div>
                        <div className="modal-solid">
                            <div className="modal-content-solid">
                                <div style={{ width: '100%', textAlign: 'center' }}><img style={{ width: "30%", margin: '30px 10px 10px 10px' }} src={logo} alt='Epic Logo' /></div>
                                <div style={{ margin: '30px', fontSize: '1.1em' }}>
                                    You are about to visit one of our travel partner's website. The partner website will open in a new tab in your browser. To return to the Member Portal, please click on this tab or close the partner website tab.
                                </div>
                                <div style={{ width: '100%', textAlign: 'center' }}>
                                    <a id='partner-link' onClick={ removeModal } href='#' target='_blank'><button style={{
                                        margin: '20px 0px',
                                        padding: '10px 20px',
                                        backgroundColor: '#031d42',
                                        width: '50%',
                                        border: '0px solid',
                                        borderRadius: '8px',
                                        color: 'white',
                                        fontFamily: 'Assistant',
                                        fontWeight: '500',
                                        fontSize: '1.2em'
                                    }} >Continue</button></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Grid container>
                        <Grid item xs={12}>
                            <div style={{ width: '100%', margin: '0px' }}>
                                <img src={banner} style={{ width: '100%' }} alt='beach image' />
                            </div>
                            <div style={{
                                fontSize: '2.5em',
                                fontFamily: 'Assistant',
                                fontWeight: 'bold',
                                width: '100%',
                                textAlign: 'center',
                                margin: '10px'
                            }}>
                                Plan My Vacation
                            </div>
                        </Grid>
                    </Grid>

                    <Grid container style={{ marginBottom: '60px' }}>
                        <Grid item xs={4} style={{ padding: '0px 40px', textAlign: 'center', width: '100%' }}>
                            <img src={image1} alt='vacation' style={{ width: '100%', borderRadius: '6px' }} />
                            <button className="action-button" onClick={() => visitPartner(rciLink)}>Book Epic Vacations & Epic Escapes</button>
                            <div style={{
                                fontSize: '1.1em',
                                fontFamily: 'Assistant',
                                fontWeight: '500',
                                width: '95%',
                                lineHeight: '150%',
                                textAlign: 'justify',
                                paddingLeft: '2.5%'
                            }}>

                                <p>Travel with your points. Go big on flexibility.<br/>
                                Enjoy condo-style stays at thousands of destinations worldwide—from Hilton Head
                                Island and the Pacific Coast to the Rocky Mountains, Gulf States, the Caribbean,
                                Greece, Mexico, and beyond. Start your next getaway here.</p>

                                <p><b>Epic Escapes</b><br/>
                                Perfect for spontaneous trips: book weeklong condo vacations <b>within 30 days of
                                arrival</b> for <b>10,000 points or less</b>.
                                </p>

                                <p><b>Epic Vacations</b><br/>                                
                                Love to plan ahead? Reserve your stay <b>up to 24 months in advance</b> for the best
                                selection and dates.</p>

                                <p><b>Need more points?</b><br/>                                
                                For larger accommodations or peak travel periods, purchase <a href="./epic-advantage-points">Epic Advantage Points</a> at a low member price to expand your
                                options.</p>
                            </div>
                        </Grid>
                        <Grid item xs={4} style={{ padding: '0px 40px', textAlign: 'center', width: '100%' }}>
                            <img src={image3} alt='vacation' style={{ width: '100%', borderRadius: '6px' }} />
                            <button className="action-button" onClick={() => visitPartner(sorLink)}>Book Epic Experiences</button>
                            <div style={{
                                fontSize: '1.1em',
                                fontFamily: 'Assistant',
                                fontWeight: '500',
                                width: '95%',
                                lineHeight: '150%',
                                textAlign: 'justify',
                                paddingLeft: '2.5%'
                            }}>
                                <p>With Epic, savings aren’t just for a single getaway — they’re for all the moments that
                                turn your trips into lasting memories throughout the year. As part of the Epic Vacations
                                family, you can tap into special member rates on hotels, cruises, vacation homes,
                                flights, and rental cars, plus curated add-ons like cooking classes, sightseeing tours,
                                and shopping and restaurant discounts.</p>
                                <p><b>Earn Member Reward Credits</b> when you book Epic Experiences, then save and
                                redeem them toward future trips. Want to earn more? Invite a friend to unlock travel
                                savings—when they book, you earn Reward Credits.</p>
                                <p>More shared trips. More earned credits. More memories on the calendar.</p>
                            </div>
                        </Grid>
                        <Grid item xs={4} style={{ padding: '0px 40px', textAlign: 'center', width: '100%' }}>
                            <img src={image2} alt='vacation' style={{ width: '100%', borderRadius: '6px' }} />
                            <Link to="/hilton-head-island-advantage"><button className="action-button">Hilton Head Island Advantage</button></Link>
                            <div style={{
                                fontSize: '1.1em',
                                fontFamily: 'Assistant',
                                fontWeight: '500',
                                width: '95%',
                                lineHeight: '150%',
                                textAlign: 'justify',
                                paddingLeft: '2.5%'
                            }}>
                                <p>Some places never go out of style — Hilton Head is one of them.
                                You chose the island for a reason. Now your membership makes returning even simpler,
                                with more options, more flexibility, and member-only savings designed to fit real-life
                                schedules. It’s no surprise Hilton Head keeps earning national love, including the <b>#1
                                Best Island in the U.S.</b> in Condé Nast Traveler’s 2025 Readers’ Choice Awards for the
                                ninth consecutive year!</p>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            }

            {owner && <Footer />}
        </div>
    )
}